import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { type RequestOtpData, requestOtpAction } from './request-otp';
import { type VerifyOtpData, verifyOtpAction } from './sign-in';

export function useRequestOtp(data: RequestOtpData) {
  return useMutation({
    mutationFn: () => requestOtpAction(data),
    onSuccess: () => {
      toast.success('OTP code sent successfully');
    },
    onError: (error: Error) => {
      toast.error(error.message ?? 'Failed to send OTP code');
    }
  });
}

export function useVerifyOtp() {
  return useMutation({
    mutationFn: (data: VerifyOtpData) => verifyOtpAction(data),
    onSuccess: () => {
      toast.success('Login successful');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to verify OTP');
    }
  });
}
